export default __webpack_public_path__ + "static/media/background.7a9253e9.png";